import { render } from "./HeaderElement.vue?vue&type=template&id=61a6629e&scoped=true"
import script from "./HeaderElement.vue?vue&type=script&lang=js"
export * from "./HeaderElement.vue?vue&type=script&lang=js"

import "./HeaderElement.vue?vue&type=style&index=0&id=61a6629e&lang=scss&scoped=true"
/* custom blocks */
import block0 from "@/locales/components/elements/header-element.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusr%2Fapp%2Fsrc%2Fcomponents%2Felements%2FHeaderElement.vue&external"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61a6629e"]])

export default __exports__